import { Button, List, Space, Typography, Popconfirm, Tag } from 'antd';
import { PlusOutlined, DeleteOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import useGisStore from '../../stores/gisStore';

const { Text } = Typography;

const FENCE_COLORS = ['#ff4d4f', '#faad14', '#52c41a', '#1890ff', '#722ed1', '#eb2f96'];

export default function GeoFencePanel() {
  const { geoFences, removeGeoFence, toggleGeoFence, drawing, startDrawing, cancelDrawing } = useGisStore();
  const isDrawing = drawing.mode === 'geoFence';

  const handleStartDraw = () => {
    startDrawing('geoFence', {
      fenceName: `电子围栏 ${geoFences.length + 1}`,
      fenceColor: FENCE_COLORS[geoFences.length % FENCE_COLORS.length],
    });
  };

  return (
    <div style={{ padding: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <Text strong style={{ fontSize: 13 }}>电子围栏</Text>
        {!isDrawing ? (
          <Button type="primary" size="small" icon={<PlusOutlined />} onClick={handleStartDraw}>
            绘制
          </Button>
        ) : (
          <Button size="small" onClick={cancelDrawing}>取消绘制</Button>
        )}
      </div>

      {isDrawing && (
        <div style={{ marginBottom: 12, padding: 8, background: '#1a1a2e', borderRadius: 4, border: '1px solid #30475e' }}>
          <Text style={{ fontSize: 11, color: '#52c41a', display: 'block', marginBottom: 4 }}>
            🖱 左键点击地图添加顶点 ({drawing.points.length}个)
          </Text>
          <Text style={{ fontSize: 11, color: '#888', display: 'block', marginBottom: 4 }}>
            右键点击完成绘制 (至少3个顶点)
          </Text>
          <Text style={{ fontSize: 11, color: '#888' }}>
            按 ESC 取消
          </Text>
          {drawing.points.length > 0 && (
            <div style={{ marginTop: 8 }}>
              <Text style={{ fontSize: 10, color: '#666', display: 'block' }}>
                已选点位:
              </Text>
              {drawing.points.map((pt, i) => (
                <Text key={i} style={{ fontSize: 10, color: '#999', display: 'block' }}>
                  {i + 1}. {pt.lon.toFixed(4)}, {pt.lat.toFixed(4)}
                </Text>
              ))}
            </div>
          )}
        </div>
      )}

      <List
        dataSource={geoFences}
        locale={{ emptyText: '暂无围栏' }}
        renderItem={(fence) => (
          <List.Item style={{ padding: '8px 0' }}>
            <Space style={{ width: '100%', justifyContent: 'space-between' }}>
              <Space>
                <Button
                  type="text"
                  size="small"
                  icon={fence.visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                  onClick={() => toggleGeoFence(fence.id)}
                  style={{ color: fence.visible ? '#1890ff' : '#666' }}
                />
                <div style={{ width: 12, height: 12, borderRadius: 2, background: fence.color }} />
                <Text style={{ fontSize: 12 }}>{fence.name}</Text>
                <Tag style={{ fontSize: 10 }}>{fence.points.length}点</Tag>
              </Space>
              <Popconfirm title="删除围栏？" onConfirm={() => removeGeoFence(fence.id)}>
                <Button type="text" size="small" danger icon={<DeleteOutlined />} />
              </Popconfirm>
            </Space>
          </List.Item>
        )}
      />
    </div>
  );
}
